import React from 'react';
import { Typography, Space, Button } from 'antd';

const { Title, Text } = Typography;

interface ActionButton {
  icon?: React.ReactNode;
  label: string;
  onClick: () => void;
  type?: 'primary' | 'default' | 'dashed' | 'link' | 'text';
  danger?: boolean;
  loading?: boolean;
}

interface AdminPageHeaderProps {
  title: string;
  description?: string;
  actions?: ActionButton[];
  extra?: React.ReactNode;
}

const AdminPageHeader: React.FC<AdminPageHeaderProps> = ({
  title,
  description,
  actions = [],
  extra
}) => {
  return (
    <div style={{
      marginBottom: '24px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start'
    }}>
      <div>
        <Title level={2} style={{ margin: 0 }}>{title}</Title>
        {description && (
          <Text type="secondary" style={{ marginTop: 4, display: 'block' }}>
            {description}
          </Text>
        )}
      </div>
      {(actions.length > 0 || extra) && (
        <Space>
          {actions.map((action, index) => (
            <Button
              key={index}
              type={action.type}
              icon={action.icon}
              onClick={action.onClick}
              danger={action.danger}
              loading={action.loading}
            >
              {action.label}
            </Button>
          ))}
          {extra}
        </Space>
      )}
    </div>
  );
};

export default AdminPageHeader;
